module.exports = __webpack_public_path__ + "img/filter.d2653c3f.svg";